export default __webpack_public_path__ + "static/media/Watch.f0a65ecb.png";